import React, { useContext, useEffect, useState } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from "../context/BasicContext";
import CardDetail from "./CardDetail";
import { SpinnerSvg, BookDot } from "./SVG"
import ImgLoader from "./ImgLoader";
import ChartA from "./ChartA";
import ChartB from "./ChartB";

//過濾條件用的temp物件
type TO= {
    [key: string]: string
}

type PDO= {
    [key: string]: string
}

const CardList =  (/*props:CardProps*/) => {
    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)

    //const [Cards, setCards] = useState<(CardProps)[]>([])
    const [nowCard, setNowCards] = useState<(CardProps)>()
    
    //分類相關20230628
    const [properties, setProperties] = useState<Properties[]>([])
    const [propertiesDictionary, setPropertiesDictionary] = useState<PDO>({})

    const [pCurrentCode, setPCurrentCode] = useState<string>("all")//現在取得的正確分類
    
    const LessonDateFormat = (timestamp: string) => {
        const match: string[] = timestamp.match(/Date\((\d+)\)/i) as string[]
        const _d = new Date(parseInt(match[1]))
        return _d.getFullYear() + "/" + (_d.getMonth() + 1) + "/" + _d.getDate()
    }
    
    const [LCurrentYear, setLCurrentYear] = useState<number>(0)
    const [RCurrentYear, setRCurrentYear] = useState<number>(0)

    const loadData = ()=>{



        bc.setCardList(undefined)
        ws.WebService.LRCurrentYearCheck().then((res: any) => { 
            setLCurrentYear(res.Data[0].LCurrentYear)
            setRCurrentYear(res.Data[0].RCurrentYear)
            return ws.WebService.getActMainList(bc.ActType, bc.Class2)
        })   
        .then((res: any) => {  
            //console.log(res)  
            const temp: (CardProps)[] = []           
            if (bc.ActType == "A" && bc.Class2 == "") {
                
                res.Data.map((item: any) => {
                    const _c: CardProps = item as CardProps         
                    if (_c.ActType == "A") temp.push(_c)
                })
            }else if (bc.ActType == "A") {                
                res.Data.map((item: any) => {
                    const _c: CardProps = item as CardProps
                    _c.isComplete = item.Complete != null  ? 4:0                    
                    temp.push(_c)
                })
            }else {
                /*
                //2025新增 壽產認列的年度
                const total:number = res.Data.reduce((a:number,c:CardProps)=>{ 
                    return (c.RecognizeYear !=null && c.RecordCompleteDate !=null && c.Hours1? a+c.Hours1: a+0)
                },0)
                */
                //console.log(total)
                res.Data.map((item: any) => {
                    const _c: CardProps = item as CardProps     
                    if(item.Complete){
                        _c.isComplete = item.Complete != null  ? 4:0
                    }
                    temp.push(_c)
                    
                    /*
                    //如果認列的年度滿6小時 只顯示已經完成並認列的年度  
                    if(total>=6){
                        _c.RecognizeYear == LCurrentYear && temp.push(_c)
                    }else{
                        temp.push(_c)
                    }*/
                })
            }
           
            //20230628設定過濾條件
            let to:TO={"all":"顯示全部"}
            let PD:PDO={}
            temp.map((item:CardProps)=>{
                item.propertyCodes=[];
                if(item.jPropertys){
                    const _ps:Properties[] = JSON.parse(item.jPropertys) as Properties[]
                    //將課程分類編號加入至propertyCodes
                    _ps.map((p:Properties)=>{
                        item.propertyCodes.push(p.PropertyCode)                        
                        to ={...to,[p.PropertyCode]:p.PropertyName}
                        PD[p.PropertyCode] = p.PropertyName
                    })
                    
                }
            })
            let to2:Properties[] = []
            for(const key in to){
                to2.push({
                    PropertyCode:key,
                    PropertyName:to[key],
                } as Properties)
            }
            setProperties(to2)
            setPropertiesDictionary(PD)
            //20230628設定過濾條件end

            //console.log(temp)
            bc.setCardList(temp)            
        })
    }

    useEffect(() => {
        loadData()
    }, [bc.Class2])

    //判斷預設是不是要開啟課程卡片
    useEffect(() => {
        if(bc.cardList && bc.ActID){
            bc.cardList.map((card: CardProps, index: number) => {
                if(card.ActID == bc.ActID){
                    bc.setOpenCard(true)
                    setNowCards(card)
                }
            })
        }
    },[bc.ActID, bc.cardList])



    const timeFormateA = (time:number):string=>{
        return `${Math.floor(time/60)}分`
    }

    const timeFormateB = (time:number, limit:number|null=null):string=>{
        //console.log(time, limit)
        if(limit && time>limit ){
            return `${Math.floor(limit*60)}分`
        }else{
            return `${Math.floor(time*60)}分`
        }
    }

    return (
        <>
            {
                bc.ActType == "A" &&
                <ChartA />
            }

            {
                (bc.ActType == "B"|| bc.ActType == "C"|| bc.ActType == "H" || bc.ActType == "I") &&
                <ChartB CurrentYear={
                    (bc.ActType == "H" ? RCurrentYear:LCurrentYear)
                } ActType={bc.ActType}/>
            }
            
            <div id="courseList">
                <select className="hibSelect" onChange={(event:React.ChangeEvent<HTMLSelectElement>)=>setPCurrentCode(event.target.value)}>
                    {
                        properties.map(
                            (item:Properties, index:number)=>
                            <option key={"property_"+index} value={item.PropertyCode}>
                                {item.PropertyName}
                            </option>
                        )
                    }
                </select>
            
                <div id="lessons">
                    {
                        //Cards.length == 0 &&
                        bc.cardList == undefined ?
                            <div className="loading">
                                <img className="spinner" src={SpinnerSvg()} />
                            </div> :
                            bc.cardList.length == 0 ?
                                <div className="no-lession">
                                    <div className="txt">
                                        <img src={BookDot()} />
                                        此分類目前沒有課程。
                                    </div>
                                </div> : ""
                    }
                    
                    {
                        //Cards.map((card: CardProps, index: number) => {
                        bc.cardList &&
                        bc.cardList.map((card: CardProps, index: number) => {
                            console.log(card)
                            //過濾條件
                            //pCurrentCode會去比對卡片中的propertyCodes代號是不是有符合選擇的類別
                            let hit:boolean = false
                            if(pCurrentCode == "all"){
                                hit= true
                            }else if(card.propertyCodes.indexOf(pCurrentCode) != -1){
                                hit= true
                            }
                            if(hit){
                                //console.log(card)
                                
                                return (
                                    <div
                                        key={"card" + index}
                                        className="lessonsTemplate lessionCard block"
                                        onClick={() => {
                                            bc.setOpenCard(true)
                                            bc.setActID(card.ActID)
                                            setNowCards(card)
                                        }}
                                    >
                                        <article >
                                        <span className="topLable">
                                            {
                                                bc.Class2 == 'B' ?"銷售資格":
                                                bc.Class2 == 'C' ?"專業課程":"法定課程"
                                            }
                                        </span>
                                            {
                                            /**
                                            <label className="year">年度</label>
                                            */
                                            }
                                            <div className="cardTitle">{card.ActTitle}</div>
                                            <div className="labels">
                                                <div>
                                                    {
                                                        card.propertyCodes.map((PID:string, index:number)=>                        
                                                            <label className="lessonLabel typeLable red" key={"typeLable_"+index}>
                                                                {propertiesDictionary[PID]}
                                                            </label>
                                                        )
                                                                
                                                    }
                                                </div>
                                                <div>
                                                    <label className="unitTitle typeLable">{card.ActID}</label>
                                                </div>
                                            </div>
                                            <div className="photo ">
                                                {
                                                /*
                                                    card.cover ?
                                                    <img className="img-thumbnail" src={card.cover} />:
                                                */
                                                }

                                                <ImgLoader ActID={card.ActID}/>
                                            
                                                {
                                                    (card.isComplete == 4 || card.RecordCompleteDate) &&
                                                    <div className="completeLession">
                                                        {
                                                             (bc.ActType=="C" || bc.ActType=="I") && 
                                                            card.實體完成 == "Y" && card.數位是否完成YN == "N" 
                                                            ?
                                                            <span className="small">
                                                                已完成實體課程
                                                            </span>
                                                            :
                                                            "已完成"
                                                        }
                                                    </div>
                                                }
                                                {
                                                    card.isComplete == 1 &&
                                                    <div className="queneLession">通報中</div>
                                                }
                                                {
                                                    card.isComplete == 2 &&
                                                    <div className="noCompleteCode" >未取得完訓碼</div>
                                                }
                                                
                                                {
                                                    card.ExamScore != null &&
                                                    <div className="completeLession">測驗通過</div>
                                                }

                                                {
                                                /**
                                                    <div className="alreadyApply" >已報名</div>
                                                */
                                                }

                                            </div>
                                            <div className="lessonInfo">
                                                {
                                                    //測驗卷不須課程時數
                                                    !card.ExamPaper &&
                                                    <div>
                                                        <span className="title">課程時數</span>
                                                        
                                                        <span className="val totalHR">{
                                                            card.Hours1?
                                                            timeFormateB(card.Hours1):
                                                            card.hours?
                                                            `${Math.round(card.hours*60)}分`:0
                                                        }</span>
                                                    </div>
                                                }
                                                {
                                                    card.ExamPaper && card.ExamScore ?
                                                    <div className="RecordTime" >
                                                        <span className="title">您的分數</span>
                                                        <span className="val">
                                                            {card.ExamScore}分
                                                        </span>
                                                    </div>
                                                    :
                                                    <div className="RecordTime" >
                                                        <span className="title">完成時數</span>
                                                        <span className="val">                                                       
                                                            {
                                                                card.RecordTime ? 
                                                                timeFormateA(card.RecordTime):
                                                                card.WatchHours?
                                                                timeFormateB(card.WatchHours, card.Hours1):0
                                                            }
                                                        </span>
                                                    </div>
                                                }
                                                <div>
                                                    <span className="title">上架日期</span>
                                                    <span className="val onDate">
                                                        {
                                                            //card.PublishDate
                                                            LessonDateFormat(card.PublishDate)
                                                        }
                                                    </span>
                                                </div>
                                                {
                                                    bc.ActType && (bc.ActType == "B" || bc.ActType == "C" || bc.ActType == "H")&&
                                                    <div>
                                                    <span className="title">認列年度</span>
                                                    <span className="val onDate">
                                                        {
                                                            card.RecognizeYear ?
                                                            (
                                                                (bc.ActType=="B" || bc.ActType=="C")?"壽險第":
                                                                bc.ActType=="H"?"產險第":""
                                                            )+card.RecognizeYear+"年度":
                                                            "尚未認列"
                                                        }
                                                    </span>
                                                    </div>
                                                }
                                                {
                                                    /** 
                                                    <div>
                                                        <span className="title">已報名人數</span>
                                                        <span className="val registrySum">0人</span>
                                                    </div>
                                                    <div>
                                                        <span className="title">上限/下限</span>
                                                        <span className="val">
                                                            <span className="maximum">0</span>/
                                                            <span className="minimum">0</span>人
                                                        </span>
                                                    </div>
                                                    <div className="date_row">
                                                        <span className="title">報名日期</span>
                                                        <span className="val BeginTime"></span>
                                                    </div>
        
                                                    <div className="date_row">
                                                        <span className="title">截止日期</span>
                                                        <span className="val EndTime"></span>
                                                    </div>
                                                    */
                                                }

                                            </div>
                                        </article>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
            <CardDetail cardData={nowCard} />



        </>
    )
}



export default CardList